import $ from 'jquery';

export default class SvelteController {
  start() {
    $('#view .view__hbs').empty().hide();
    $('#view .view__svelte').show();
  }

  exit() {
    $('#view .view__hbs').empty().show();
    $('#view .view__svelte').hide();
  }
}
